export default function(value) {
  return new Intl.NumberFormat("en-US").format(value).replace(/,/gi, "");
}